import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const TestQuizLoadable = Loadable({
    loader: (): any => import('./TestQuiz').then((res) => res.TestQuiz),
    loading: <Loader/>,
});
